const map = { stripe: 'Stripe', google_analytics: 'Google Analytics', github: 'GitHub', jira: 'Jira' }

const Integrations = props => (
  props.integrations.length > 0
    ?
    <div className='col-5'>
      <div className='settings-title col-12 center'>Integration Settings</div>
      { props.integrations.map(s =>
        <div
          key={s}
          className={`integration${props.integration === s ? '-selected' : ''} col-12`}
          onClick={() => props.onClick(s)}>
          { map[s] }
        </div>
      ) }
      <button className='danger col-12' onClick={props.onRemove} disabled={!props.integration}>
        Remove
      </button>
    </div>
    : 'You have no service integrations'
)

export default Integrations